import { mergeAttributes, Node } from "@tiptap/core";

export const NWAnchorAdapter = Node.create({
  name: "nw-anchor",
  group: "block",
  draggable: false,
  selectable: false,
  content: "block*",

  addAttributes() {
    return {
      id: {
        default: null,
        parseHTML: element => element.getAttribute("id"),
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "nw-anchor",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["nw-anchor", mergeAttributes(HTMLAttributes), 0];
  },
});
